import { HTMLAttributes } from "react";
import { Button } from "@teamscheme/button";
import { EVENTS } from "../../Tracking";
import ZoomableScrollImage from "../preview/ZoomableImage";
import styled from "styled-components";
import { onDesktop } from "@teamscheme/theme";
import MagnifyingGlassSvg from "./illustrations/magnifying-glass-plus.svg";

export interface DummySectionProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
  onStartNew(): void;
}

const DummyBody = styled.div`
  margin-bottom: 2em;
  p {
    line-height: 1.75;
  }
`;
const Overlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;
const OverlayBackground = styled(Overlay)`
  background: black;
  opacity: 0.1;
  transition: opacity 0.25s ease;
`;
const Zoom = styled.div`
  font-weight: bold;
  padding: 2em 3em;
  border-radius: 4em;
  background: white;
  display: flex;
  align-items: center;
  transition: box-shadow 0.25s ease;

  img {
    width: 1.5em;
    height: 1.5em;
    margin-right: 1em;
  }
`;
const DummyContract = styled.div`
  margin: auto;
  max-width: 720px;
  max-height: 400px;
  overflow-y: hidden;
  position: relative;
  transition: box-shadow 0.25s ease;

  &:hover {
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.1);
  }

  &:hover,
  &:active {
    ${OverlayBackground} {
      opacity: 0.05;
    }
  }

  &:hover,
  &:active {
    ${Zoom} {
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
    }
  }
`;

export const DummySection = styled(function ({
  onStartNew,
  ...props
}: DummySectionProps) {
  return (
    <div {...props}>
      <DummyBody>
        <h2>Hva inneholder en kjøpekontrakt?</h2>
        <p>
          Våre advokater har utarbeidet NAF Kjøpekontrakt slik at den inneholder
          nødvendige opplysninger om kjøretøyet, dens tilstand, utstyr som
          følger med, informasjon om oppgjøret og partenes personopplysninger.
        </p>
        <p>
          Basert på registreringsnummeret vil feltene i kontrakten tilpasses for
          alt fra personbil, til MC, minibuss, campingvogn, bobil, tilhenger
          m.m. Kontrakten bør fylles ut med alle forhold som en kjøper og selger
          har blitt enige om både muntlig og skriftlig.
        </p>
        <Button linkTo="/" variant="outline" onClick={onStartNew}>
          Kom i gang med utfyllingen
        </Button>
      </DummyBody>
      <DummyContract>
        <ZoomableScrollImage
          className="DocumentPreview"
          alt=""
          src="/dummy-contracts/kjopekontrakt-for-bruktbil-220101.png"
          onOpenEvent={EVENTS.LANDING_PAGE.OPEN_PREVIEW}
        />
        <OverlayBackground />
        <Overlay>
          <Zoom>
            <img alt="Zoom" src={MagnifyingGlassSvg} />
            Forhåndsvisning
          </Zoom>
        </Overlay>
      </DummyContract>
    </div>
  );
})`
  display: flex;
  flex-direction: column;

  ${({ theme }) => onDesktop`
    flex-direction: row;

    ${DummyBody}{
      padding-right: ${theme.spacing.space120}
    }
  `}
`;
